export default "__VITE_ASSET__C3GnvChW__"